import type { IconProps } from '@twistopayments/design-system/icons/constants'
import {
  CardOutlineIcon,
  ExpensesOutlineIcon,
  InstallmentsOutlineIcon,
  InsuranceOutlineIcon,
  PhoneIcon,
  SnapOutlineIcon,
  SplitIcon,
  TwistoOutlineIcon,
  UserOutlineIcon,
} from '@twistopayments/design-system/icons/inline'

import type { Category } from '@twisto/api-cms'

type Props = {
  icon?: Category['icon']
  className?: string
} & IconProps

export const CategoryIcon = ({ icon, className, size, color }: Props) => {
  let Icon

  switch (icon) {
    case 'card':
      Icon = CardOutlineIcon
      break
    case 'expenses':
      Icon = ExpensesOutlineIcon
      break
    case 'installments':
      Icon = InstallmentsOutlineIcon
      break
    case 'insurance':
      Icon = InsuranceOutlineIcon
      break
    case 'phone':
      Icon = PhoneIcon
      break
    case 'snap':
      Icon = SnapOutlineIcon
      break
    case 'split':
      Icon = SplitIcon
      break
    case 'twisto':
      Icon = TwistoOutlineIcon
      break
    case 'user':
      Icon = UserOutlineIcon
      break
    default:
      return null
  }

  return <Icon className={className} color={color} size={size} />
}
